import Styles from "./Default.module.css";

const Default = ({ primary }) => {
	console.log("embed", primary);
	return (
		<section className={Styles.wrapper}>
			<div className={Styles.container} data-contain="true">
				<div
					className={Styles.embedContainer}
					dangerouslySetInnerHTML={
						primary?.oembed?.html
							? { __html: primary?.ombed?.html }
							: {
									__html: primary?.iframe,
								}
					}
				></div>
			</div>
		</section>
	);
};

export default Default;
